import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Muestra un metacampo de la variante seleccionada y lo actualiza al cambiar de variante.
 */
class VariantMetafield extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * @param {import('@shopify/events').ProductSelectEvent} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const updated = detail.html.querySelector(`variant-metafield[data-block-id="${this.dataset.blockId}"]`);
        if (!(updated instanceof HTMLElement)) return;

        morph(this, updated, { childrenOnly: true });
        this.hidden = updated.hidden;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[variant-metafield] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('variant-metafield')) {
  customElements.define('variant-metafield', VariantMetafield);
}
